import { css } from '@emotion/react';

export const cellsStyle = () =>
  css({
    display: 'flex',
    alignItems: 'center',
  });
